const delta = (item, oldItem) => {
  let res = {}
  if (!oldItem) return item
  for (let f in item) { if (item[f] !== oldItem[f]) res[f] = item[f] }
  return res
}

export default delta
